import React from "react";
import {Template} from "../../components/Template/Template";
import Image from "../../components/Image/Image";
import {getImageUrl} from "../../lib/utils";
import DialogSentence from "../../components/DialogSentence/DialogSentence";
import {parseSentenceWithHighlights} from "../../lib/cms_utils";
import styles from "./TextIllustrated.module.css";

const TextIllustrated = ({ blockData, contentIndex, audioUrl }) => {

    const imageSrc = blockData.content[contentIndex] && blockData.content[contentIndex].img ? blockData.content[contentIndex].img : undefined;

    let sentences  = [];
    const characterClassName = {};

    if(blockData.content[contentIndex] && blockData.content[contentIndex].type === 'dialog') {
        sentences = blockData.content[contentIndex].sentences;
        sentences.forEach((sentence, index) => {
            if(!characterClassName[sentence.character]) {
                characterClassName[sentence.character] = styles['character' + (index + 1)];
            }
        });
    }

    return (

        <Template className={styles.container}
                  showInstruction={blockData.content[contentIndex].type === 'instruction'}
                  instructionText={blockData.content[contentIndex].instruction} audioUrl={audioUrl} >

            {imageSrc && <Image className={styles.imageContainer} src={getImageUrl(imageSrc)} />}

            <div className={styles.sentences}>
                {sentences && sentences.map((sentence, index) => (
                    <DialogSentence key={index}
                                    character={sentence.character}
                                    className={`${characterClassName[sentence.character]}`}
                                    sentenceFragments={parseSentenceWithHighlights(sentence.text)}/>
                ))}

            </div>


        </Template>
    );
}

export default TextIllustrated;